import { Link } from 'react-router-dom';
import { Mail, Instagram } from 'lucide-react';

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="relative z-10 border-t border-slate-200/50 bg-white/40 backdrop-blur-lg">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <h3 className="text-xl font-semibold text-slate-900 font-['Outfit']">JF-NEXUS</h3>
            <p className="mt-3 text-sm text-slate-500 leading-relaxed">
              Webpräsenz als Service.<br />
              Wie Strom aus der Steckdose.
            </p>
            <p className="mt-4 text-sm text-slate-500">
              Für Klein- und Mittelständische Unternehmen.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-slate-900 uppercase tracking-wider font-['Outfit']">Rechtliches</h4>
            <div className="mt-4 space-y-3">
              <Link to="/impressum" className="block text-sm text-slate-500 hover:text-purple-600 transition-colors" data-testid="footer-impressum-link">
                Impressum
              </Link>
              <Link to="/datenschutz" className="block text-sm text-slate-500 hover:text-purple-600 transition-colors" data-testid="footer-datenschutz-link">
                Datenschutz
              </Link>
            </div>
          </div>

            <div>
            <h4 className="text-sm font-semibold text-slate-900 uppercase tracking-wider font-['Outfit']">Kontakt</h4>
            <div className="mt-4 space-y-3">
              <a
                href="mailto:info@jf-nexus.de"
                className="flex items-center gap-2 text-sm text-slate-500 hover:text-purple-600 transition-colors"
                data-testid="footer-email-link"
              >
                <Mail size={14} />
                info@jf-nexus.de
              </a>
              <a
                href="https://instagram.com/jfnexus"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-sm text-slate-500 hover:text-purple-600 transition-colors"
                data-testid="footer-instagram-link"
              >
                <Instagram size={14} />
                @jfnexus
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-200/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-400">
            &copy; {new Date().getFullYear()} JF-NEXUS &mdash; Jens Mäder & Florian Fuß GbR
          </p>
          <p className="text-xs text-slate-300">
            Fehnstr. 16, 96317 Kronach
          </p>
        </div>
      </div>
    </footer>
  );
}
